
import { ItensDevolucao } from "app/types/pesquisa-orcamento/consultas/sub-consultas-devolucoes/Itens";
import globalMU from "globalMU";
import React from "react";

export type DevolucoesItensProps = {
    itensDevolucoes: ItensDevolucao[]
    mostrarDetalhesItensDevolucao: boolean
    onMostrarDetalhesItensDevolucao: (mostrar: boolean, item: ItensDevolucao) => void
    itemSelecionado: ItensDevolucao
};

export const DevolucoesItens = (props: DevolucoesItensProps) => {

    const tiposEntrega = (notaFiscal: ItensDevolucao) => {
        return <>
            <div>
                <div className="_my-3 _w-full _bg-[#f5f5f5] _mb-0 _py-3 _px-4 _rounded-t-lg _border _border-gray-300 _font-semibold">
                    <h4>
                        <label className="hover:_cursor-pointer hover:_text-[#409fff]" onClick={() => props.onMostrarDetalhesItensDevolucao(!props.mostrarDetalhesItensDevolucao, notaFiscal)}>
                            {
                                'Produto:' + notaFiscal.CodigoProduto +
                                ' - Descrição: ' + notaFiscal.DescricaoProduto +
                                ' - Preço Total: ' + notaFiscal.PrecoTotal
                            }
                        </label>
                    </h4>
                </div>
                {props.mostrarDetalhesItensDevolucao && props.itemSelecionado.CodigoProduto == notaFiscal.CodigoProduto &&
                    <div className="_bg-[#ffffff] _p-4 b _border _border-gray-300 _border-t-0">
                        <div className="_flex _items-start">
                            <div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Nota Fiscal de Saída</label>
                                    <p className="_mb-0 _p-2">{notaFiscal.NotaDevolvida ? notaFiscal.NotaDevolvida.CodigoFilial + '/' + notaFiscal.NotaDevolvida.Numero.trim() + '-' + notaFiscal.NotaDevolvida.Serie : ''}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Produto</label>
                                    <p className="_mb-0 _p-2">{notaFiscal.CodigoProduto}</p>
                                </div>

                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Descrição</label>
                                    <p className="_mb-0 _p-2">{notaFiscal.DescricaoProduto}</p>
                                </div>
                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Código Fabricante</label>
                                    <p className="_mb-0 _p-2">{notaFiscal.CodigoFabricante}</p>
                                </div>

                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Quantidade</label>
                                    <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(notaFiscal.Quantidade, 3, false)}</p>
                                </div>

                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Unidade</label>
                                    <p className="_mb-0 _p-2">{notaFiscal.UnidadeMedida}</p>
                                </div>

                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Preço Unitário</label>
                                    <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(notaFiscal.Preco, 2, true)}</p>
                                </div>

                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Desconto Unitário</label>
                                    <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(notaFiscal.DescontoUnitario, 2, true)}</p>
                                </div>

                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">IPI</label>
                                    <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(notaFiscal.ValorIPI, 2, true)}</p>
                                </div>

                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">IPI</label>
                                    <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(notaFiscal.ValorIPI, 2, true)}</p>
                                </div>

                                <div className="_flex _items-center">
                                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Preço Total</label>
                                    <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(notaFiscal.QuantidadeDevolvida, 3, false)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>

        </>
    }

    return (
        <div className="_my-4">

            {props.itensDevolucoes?.map((item) => {
                return tiposEntrega(item)
            })}
        </div>
    )

}